<router-outlet></router-outlet>
<div id="logoutModal" class="modal">
    <div class="modal-content">
        <span class="close" id="closeModal">&times;</span>
        <p>{{'SESSION_DISCONNECTED' | translate}}</p>
        <button id="confirmLogout">{{'ACCEPT' | translate}}</button>
    </div>
</div>
